module.exports = __webpack_public_path__ + "img/76_7.1cf9fc56.png";